import React, { useEffect } from 'react';
import { withTranslation } from 'react-i18next';
import { useTitleDispatch } from '../TitleContextProvider';
import { AccordionWrapper } from 'react-lib/dist/components-es';
import BSearch from './BSearch';
import i18n from 'i18next';

const BSearchContainer = ({ buildingNum, id, t }) => {
  const dispatch = useTitleDispatch();

  useEffect(() => {
    dispatch({
      pageTitle: t('building.generic.search.for.a.building.label')
    });
  }, [i18n.language]);

  const getContainerBody = () => {
    return (
      <AccordionWrapper
        closable={false}
        accordionTitle="building.generic.search.for.a.building.label"
        render={() => <BSearch />}
        className={buildingNum || id ? 'containerReducedWhiteSpace' : ''}
      />
    );
  };

  return getContainerBody();
};
export default withTranslation()(BSearchContainer);
